import { isEqual } from 'lodash';
import { useDispatch } from 'react-redux';
import {
  createPersonSSN,
  updatePersonSSN,
} from '../store/actions/person/personActions';
import useApplicationUid from './useApplicationUid';

const usePersonSsnDispatch = () => {
  const dispatch = useDispatch();
  const { ApplicationUid } = useApplicationUid();

  const personSsnDispatch = ({ personUid, data, defaultValues, onSuccess }) => {
    const shouldSkip = isEqual(data, defaultValues);

    if (shouldSkip) {
      onSuccess();
      return;
    }

    const requestData = {
      ApplicationUid,
      PersonUid: personUid,
      data,
      onSuccess,
    };

    if (defaultValues.Ssn) {
      dispatch(
        updatePersonSSN({
          ...requestData,
        }),
      );
      return;
    }

    dispatch(
      createPersonSSN({
        ...requestData,
      }),
    );
  };

  return { personSsnDispatch };
};

export default usePersonSsnDispatch;
